import { render, staticRenderFns } from "./live-track.vue?vue&type=template&id=023f0cc0&"
import script from "./live-track.vue?vue&type=script&lang=js&"
export * from "./live-track.vue?vue&type=script&lang=js&"
import style0 from "./live-track.vue?vue&type=style&index=0&id=023f0cc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports